import * as types from './types'

export const selectTab = tab => ({
    type: types.SELECT_TAB,
    tab
})